module.exports = __webpack_public_path__ + "static/img/padlock.de38474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padlock.png
// module id = gTXK
// module chunks = 1